import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const SKUDetailManufacturingOrders=({parentId,application,userData,parent})=>{
    const list_name='sku_manufacturing_orders';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                parent={parent}
                application={application}
                userData={userData}
                entityType={'ManufacturingOrder'}
                entityParams={['sku_id='+parentId,'_context='+['parent_name=SKU'],'_lang='+application.globalData.lang]}
                list_name={list_name}
                file={'SKUDetailManufacturingOrders.js'}
                navigateOnNew={null}
                canCreateNew={false}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name]]);

    return(renderListTab);
}
export default SKUDetailManufacturingOrders;
